import React from 'react';
import { OfficeBuildingIcon } from '@heroicons/react/outline';
import { Copy, Lock, UsersThree } from 'phosphor-react';

// Define proper props interface
interface ProjectVisibilityAndForkPillsProps {
  isForked: boolean;
  isPrivate: string;
}

// Change function signature to accept props object
export const ProjectVisibilityAndForkPills = ({
  isForked,
  isPrivate,
}: ProjectVisibilityAndForkPillsProps) => {
  return (
    <>
      {isPrivate === 'private' ? (
        <div
          style={{
            borderRadius: '24px',
            padding: '0',
            color: '#D7D7DB',
            backgroundColor: '#343B45',
            fontSize: '12px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
            cursor: 'pointer',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            width: '32px',
            height: '32px',
            position: 'relative',
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.width = '100px';
            const label = e.currentTarget.querySelector('.label') as HTMLElement;
            if (label) {
              label.style.transform = 'translateX(0)';
              label.style.opacity = '1';
            }
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.width = '32px';
            const label = e.currentTarget.querySelector('.label') as HTMLElement;
            if (label) {
              label.style.transform = 'translateX(-100%)';
              label.style.opacity = '0';
            }
          }}
        >
          <div
            style={{
              width: '32px',
              height: '32px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0,
              zIndex: 2,
            }}
          >
            <Lock />
          </div>
          <span
            className="label"
            style={{
              position: 'absolute',
              left: '25px',
              transform: 'translateX(-100%)',
              opacity: '0',
              transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
              fontSize: '12px',
              paddingLeft: '6px',
              whiteSpace: 'nowrap',
            }}
          >
            Only Me
          </span>
        </div>
      ) : isPrivate === 'public' ? (
        <div
          style={{
            borderRadius: '24px',
            padding: '0',
            color: '#D7D7DB',
            backgroundColor: '#343B45',
            fontSize: '12px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
            cursor: 'pointer',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            width: '32px',
            height: '32px',
            position: 'relative',
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.width = '140px';
            const label = e.currentTarget.querySelector('.label') as HTMLElement;
            if (label) {
              label.style.transform = 'translateX(0)';
              label.style.opacity = '1';
            }
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.width = '32px';
            const label = e.currentTarget.querySelector('.label') as HTMLElement;
            if (label) {
              label.style.transform = 'translateX(-100%)';
              label.style.opacity = '0';
            }
          }}
        >
          <div
            style={{
              width: '32px',
              height: '32px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0,
              zIndex: 2,
            }}
          >
            <UsersThree size={16} />
          </div>
          <span
            className="label"
            style={{
              position: 'absolute',
              left: '25px',
              transform: 'translateX(-100%)',
              opacity: '0',
              transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
              fontSize: '12px',
              paddingLeft: '6px',
              whiteSpace: 'nowrap',
            }}
          >
            Anyone Can See
          </span>
        </div>
      ) : isPrivate === 'organization' ? (
        <div
          style={{
            borderRadius: '24px',
            padding: '0',
            color: '#D7D7DB',
            backgroundColor: '#343B45',
            fontSize: '12px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
            cursor: 'pointer',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            width: '32px',
            height: '32px',
            position: 'relative',
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.width = '120px';
            const label = e.currentTarget.querySelector('.label') as HTMLElement;
            if (label) {
              label.style.transform = 'translateX(0)';
              label.style.opacity = '1';
            }
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.width = '32px';
            const label = e.currentTarget.querySelector('.label') as HTMLElement;
            if (label) {
              label.style.transform = 'translateX(-100%)';
              label.style.opacity = '0';
            }
          }}
        >
          <div
            style={{
              width: '32px',
              height: '32px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0,
              zIndex: 2,
            }}
          >
            <OfficeBuildingIcon
              style={{
                width: '16px',
                height: '16px',
                color: '#D7D7DB',
              }}
            />
          </div>
          <span
            className="label"
            style={{
              position: 'absolute',
              left: '32px',
              transform: 'translateX(-100%)',
              opacity: '0',
              transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
              fontSize: '12px',
              paddingLeft: '6px',
              whiteSpace: 'nowrap',
            }}
          >
            Organization
          </span>
        </div>
      ) : null}

      {isForked && (
        <div
          style={{
            borderRadius: '24px',
            padding: '0',
            color: '#D7D7DB',
            backgroundColor: '#343B45',
            fontSize: '12px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
            cursor: 'pointer',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            width: '32px',
            height: '32px',
            position: 'relative',
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.width = '150px';
            const label = e.currentTarget.querySelector('.label') as HTMLElement;
            if (label) {
              label.style.transform = 'translateX(0)';
              label.style.opacity = '1';
            }
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.width = '32px';
            const label = e.currentTarget.querySelector('.label') as HTMLElement;
            if (label) {
              label.style.transform = 'translateX(-100%)';
              label.style.opacity = '0';
            }
          }}
        >
          <div
            style={{
              width: '32px',
              height: '32px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0,
              zIndex: 2,
            }}
          >
            <Copy weight="fill" size={16} />
          </div>
          <span
            className="label"
            style={{
              position: 'absolute',
              left: '32px',
              transform: 'translateX(-100%)',
              opacity: '0',
              transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
              fontSize: '12px',
              paddingLeft: '6px',
              whiteSpace: 'nowrap',
            }}
          >
            Duplicated Project
          </span>
        </div>
      )}
    </>
  );
};
